import { render, staticRenderFns } from "./CreditorVouchersTable.vue?vue&type=template&id=4c13663e&scoped=true&"
import script from "./CreditorVouchersTable.vue?vue&type=script&lang=js&"
export * from "./CreditorVouchersTable.vue?vue&type=script&lang=js&"
import style0 from "./CreditorVouchersTable.vue?vue&type=style&index=0&id=4c13663e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c13663e",
  null
  
)

export default component.exports